import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Button, Dialog, DialogTitle, IconButton, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FlexContainer } from "../../../styles/common/FlexBox";
import { useNavigate, useLocation } from "react-router-dom";

const Search = ({ searchValue, setSearchValue, customColor }) => {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleModalSearch = () => {
    const queryParams = new URLSearchParams(location.search);

    searchValue
      ? queryParams.set("name", searchValue)
      : queryParams.delete("name");

    navigate({
      pathname: location.pathname,
      search: queryParams.toString(),
    });

    // fecha o modal após a busca
    handleClose();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleModalSearch();
    }
  };

  return (
    <React.Fragment>
      <SearchIcon onClick={handleClickOpen} sx={{ color: customColor || "white", cursor: "pointer" }} />

      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        sx={{
          alignItems: "center",
          display: "flex",
          gap: "1vw",
          justifyContent: "center",
        }}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            fontSize: "20px",
            alignItems: "center",
            gap: "1vw",
          }}
          id="customized-dialog-title"
        >
          <SearchIcon sx={{ color: "black" }} />
          Digite a sua Loja aqui
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{ color: (theme) => theme.palette.grey[500] }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <FlexContainer
          direction="column"
          justify="center"
          align="center"
          gap="0.5rem"
          margin="0 0 1rem 0"
        >
          <TextField
            id="outlined-basic"
            variant="outlined"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={handleKeyDown} // Enter dispara busca
            sx={{
              "& .MuiInputBase-input": {
                height: "1em",
              },
            }}
          />
          <Button variant="outlined" onClick={handleModalSearch}>
            Buscar
          </Button>
        </FlexContainer>
      </Dialog>
    </React.Fragment>
  );
};

export default Search;